import { useEffect, useRef } from "react";

interface ShortcutHandlers {
  enabled: boolean;
  onFocusQuickFind: () => void;
  onMoveFocus: (delta: 1 | -1) => void;
  onOpenFocused: () => void;
  onToggleSelectFocused: () => void;
  onEscape: () => void;
  onSwitchTab: (index: number) => void;
  onHelp: () => void;
}

// /  focus quick find · j/k move · Enter open · x select · Esc close · 1–6 tabs · ? help
export function useWorklistShortcuts(handlers: ShortcutHandlers) {
  const ref = useRef(handlers);
  ref.current = handlers;

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const h = ref.current;
      if (!h.enabled) return;
      if (e.key === "Escape") return h.onEscape();

      const el = document.activeElement as HTMLElement | null;
      const typing =
        !!el &&
        (/INPUT|SELECT|TEXTAREA/.test(el.tagName) || el.isContentEditable);
      if (typing || e.ctrlKey || e.metaKey || e.altKey) return;

      if (e.key === "/") {
        e.preventDefault();
        h.onFocusQuickFind();
      } else if (e.key === "?") h.onHelp();
      else if (e.key === "j") h.onMoveFocus(1);
      else if (e.key === "k") h.onMoveFocus(-1);
      else if (e.key === "Enter") h.onOpenFocused();
      else if (e.key === "x") h.onToggleSelectFocused();
      else if (/^[1-6]$/.test(e.key)) h.onSwitchTab(+e.key - 1);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);
}
